var exports = {
  "k": "StackUserAvatar.module__container___b0FMcW",
};

module.exports = exports;
